import { render, staticRenderFns } from "./finance-totals.vue?vue&type=template&id=0c8ce686&"
import script from "./finance-totals.ts?vue&type=script&lang=js&"
export * from "./finance-totals.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports